import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, InfiniteScroll } from 'ionic-angular';
import { IPlanning } from '../../../typings/timetracker/timetracker';
import { Observable } from 'rxjs/Observable';
import { filter, isEmpty } from 'lodash';
import * as moment from 'moment';
import { IPlanningListResponse } from '../../../typings/api';
import { PlanningService } from '../../providers/planning.service';
import { DailyTotalsDetailsPage } from '../daily-totals-details/daily-totals-details';

/**
 * Generated class for the DailyTotalsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-daily-totals-overview',
  templateUrl: 'daily-totals-overview.html',
})
export class DailyTotalsOverviewPage {

  public planning$: Observable<IPlanningListResponse>;
  private NUMBER_OF_ITEMS = 25;
  private LIMIT = 25;
  private infiniteScroll: InfiniteScroll;

  showDetails( planning: IPlanning ) {
    this.navCtrl.push( DailyTotalsDetailsPage, planning );
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DailyTotalPage');

    this.$planningAPI.dispatchPlanningFetchAll( this.LIMIT, 0 );
  }

  doInfinite( infiniteScrollEvent: InfiniteScroll ) {
    this.infiniteScroll = infiniteScrollEvent;
    this.LIMIT += this.NUMBER_OF_ITEMS;
    this.$planningAPI.dispatchPlanningFetchAll( this.LIMIT, 0 );
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private $planningAPI: PlanningService ) {
      this.planning$ = this.$planningAPI.selectPlanningFetchAll()
      .do( ( planning ) => {
        if ( this.infiniteScroll && this.infiniteScroll.state === 'loading' ) {
          this.infiniteScroll.complete();
        }
      } )
      .filter( planning => !isEmpty( planning ) )
      .map( ( planning ) => {
        const today = moment().startOf( 'day' ).add( 1, 'day' );
        planning.items = filter( planning.items, item => today.isAfter( moment( item.start_time ) ) );
        return planning;
      } );

  }
}



// WEBPACK FOOTER //
// ./src/pages/daily-totals-overview/daily-totals-overview.ts